
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Confirm = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [activeSection, setActiveSection] = useState('about');

  useEffect(() => {
    const confirmEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Invalid confirmation link');
        return;
      }

      try {
        console.log('Confirming email with token:', token);
        
        // Call the edge function directly with the token as a URL parameter
        const functionUrl = `https://ifkrklrmsjszdloohxvx.supabase.co/functions/v1/confirm-email?token=${encodeURIComponent(token)}`;
        
        const response = await fetch(functionUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imlma3JrbHJtc2pzemRsb29oeHZ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc2NDc3NTIsImV4cCI6MjA5MzIyMzc1Mn0.s6vfvYJPNbez6rWRYA2Po61OW4CC7CSabvk18-mkITo`
          }
        });

        const data = await response.json();
        console.log('Response:', { data, status: response.status });

        if (!response.ok) {
          console.error('Function error:', data);
          setStatus('error');
          setMessage(data?.error || 'Failed to confirm email');
          return;
        }

        if (data?.success) {
          setStatus('success');
          setMessage(data.message);
          setEmail(data.email);
        } else {
          setStatus('error');
          setMessage(data?.error || 'Failed to confirm email');
        }
      } catch (error) {
        console.error('Network error:', error);
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    };

    confirmEmail();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header activeSection={activeSection} onSectionChange={setActiveSection} />
      <main className="flex-1 flex items-center justify-center py-20">
        <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {status === 'loading' && (
            <div className="bg-blue-50 rounded-2xl p-8 border border-blue-200">
              <div className="w-16 h-16 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin mx-auto mb-4"></div>
              <h1 className="text-2xl font-bold text-blue-900 mb-2">Confirming your email...</h1>
              <p className="text-blue-600">Please wait while we verify your email address.</p>
            </div>
          )}

          {status === 'success' && (
            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-2xl p-8 border border-green-200">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 border-2 border-green-500 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
              </div>
              <h1 className="text-3xl font-bold text-blue-900 mb-2">Filter the Noise</h1>
              <h2 className="text-xl font-semibold text-blue-700 mb-4">Your Digital Guardian</h2>
              <p className="text-blue-700 mb-4">{message}</p>
              {email && (
                <p className="text-blue-600 mb-6">
                  {email} has been successfully added to SocialScoop waitlist.
                </p>
              )}
              <p className="text-blue-600">
                You'll be among the first to experience our digital guardian that helps you <strong>filter the noise</strong> from your social media feeds. Take control of what comes in and what stays out.
              </p>
            </div>
          )}

          {status === 'error' && (
            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-8 border border-red-200">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 border-2 border-red-500 rounded-full flex items-center justify-center">
                  <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                </div>
              </div>
              <h1 className="text-3xl font-bold text-blue-900 mb-4">Confirmation Failed</h1>
              <p className="text-xl text-blue-700 mb-4">{message}</p>
              <p className="text-blue-600">
                You may need to request a new confirmation email or the link may have expired. Please try signing up again.
              </p>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Confirm;
